// extracted by mini-css-extract-plugin
export default {"container":"TeamSelector_container__5gcwr"};